import { useEffect, useRef, useState } from 'react';
import { registry } from './registry';

let idValue = 0;

function generateId(): number {
  const result = idValue++;
  if (idValue > 0xffffff) {
    idValue = 0;
  }
  return result;
}

interface PopupProps {
  open: boolean;
  name?: string;
  onClose?: () => void;
  onResolve?: (result: any) => void;
  onReject?: (reason?: any) => void;
  children: React.ReactNode;
  [key: string]: any;
}

export const Popup = (props: PopupProps) => {
  const idRef = useRef<number>(generateId());
  const [closed, setClosed] = useState<boolean>(false);

  const resolve = (result: any): void => {
    if (!closed) {
      setClosed(true);
      if (props.open) {
        props.onResolve?.(result);
        props.onClose?.();
      }
    }
  };

  const reject = (reason?: any): void => {
    if (!closed) {
      setClosed(true);
      if (props.open) {
        props.onReject?.(reason);
        props.onClose?.();
      }
    }
  };

  const updateLayer = (): void => {
    const currentLayer = registry.layer();
    currentLayer.updateWindow({ id: idRef.current, resolve, reject }, props.children, { ...props, open }, props.name);
  };

  useEffect(() => {
    if (props.open) {
      updateLayer();
    } else {
      const currentLayer = registry.layer();
      currentLayer.removeWindow(idRef.current);
    }

    return () => {
      const currentLayer = registry.layer();
      currentLayer.removeWindow(idRef.current);
      if (props.open) {
        reject();
      }
    };
  }, [open, props.children, props.name]);

  return null;
};
